module.exports = __webpack_public_path__ + "img/faviconbw.0d3d05f2.png";